import React from 'react';
import { Mentions as AntMentions } from 'antd';

/**
 * Wrapper component for Ant Design Mentions
 * 
 * This wrapper allows us to easily replace Ant Design in the future without changing all imports.
 * It preserves all Ant Design Mentions functionality including options, prefix, and onSelect options.
 * 
 * @component
 * @example
 * import { Mentions } from '../GeneralComponents/ui';
 * 
 * const { Option } = Mentions;
 * 
 * <Mentions
 *   style={{ width: '100%' }}
 *   placeholder="input @ to mention someone"
 * >
 *   <Option value="afc163">afc163</Option>
 *   <Option value="zombieJ">zombieJ</Option>
 * </Mentions>
 * 
 * @see https://ant.design/components/mentions/ - Ant Design Mentions documentation
 */
const Mentions = AntMentions;

export default Mentions;

